const url = process.env.REACT_APP_API_URL;

export default class RoleServices {

    constructor() {
        this.url = process.env.REACT_APP_API_URL;
    }

    static getRoles() {
        return fetch(`${url}/role`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addRole(role) {
        return fetch(`${url}/role`, {
            method: 'POST',
            body: JSON.stringify(role),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateRole(role) {
        return fetch(`${url}/role`, {
            method: 'PUT',
            body: JSON.stringify(role),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteRole(roleId) {
        return fetch(`${url}/role`, {
            method: 'DELETE',
            body: JSON.stringify(roleId),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }


}